import Component from '../inherited/Component'
import axios from 'axios'
import AjaxApi from '../lib/AjaxApi'

export default class CollectionFilters extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._filterTriggers = this._elem.querySelectorAll('[data-collection-filter-trigger]')
    this._sortDropdowns = this._elem.querySelectorAll('[data-sort-dropdown]')
    this._sortTriggers = this._elem.querySelectorAll('[data-sort-trigger]')
    this._offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-outer-height')) || 0
    this._mobileContainer = this._elem.querySelector('[data-collection-filters-mobile]')
    this._mobileScrollContainer = this._mobileContainer.querySelector('[data-collection-filters-scroll]')
    this._ctx.hydrate({ CollectionFiltersMounted: this._ctx.getState().CollectionFiltersMounted || false })
    this._scrollElem = this._elem.querySelector('[data-collection-filters-scroll-to]')
    this._priceTriggers = this._elem.querySelectorAll('[data-collection-filter-price-trigger]')
    this._filterToggles = document.querySelectorAll('[data-collection-filter-toggle]')
  }

  mount = async () => {

    // if(window.innerWidth > 834) {
    //   let filterHeight = window.innerHeight - this._mobileScrollContainer.querySelector('.scroll-area').getBoundingClientRect().top - 16
    //   this._mobileScrollContainer.querySelector('.scroll-area').style.height = `${filterHeight}px`
    //   window.addEventListener('scroll', e => {
    //     filterHeight = window.innerHeight - this._mobileScrollContainer.querySelector('.scroll-area').getBoundingClientRect().top - 16
    //     this._mobileScrollContainer.querySelector('.scroll-area').style.height = `${filterHeight}px`
    //   }, { passive: true })
    // }

    this._sortDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', async (e) => {
        e.preventDefault()
        const url = this._updateURLParams('sort_by', dropdown.value)
        await this._refreshCollection(url, undefined, e)
      })
    })

    this._sortTriggers.forEach(elem => {
      elem.addEventListener('click', async (e) => {
        e.preventDefault()
        const url = this._updateURLParams('sort_by', elem.dataset.sortTrigger)
        const openFilters = this._getOpenFilters()

        await this._refreshCollection(url, () => {
          openFilters.forEach(filter => this._openFilter(filter))
        }, e)
      })
    })

    this._priceTriggers.forEach(trigger => {
      trigger.addEventListener('update-filter', async (e) => {
        e.preventDefault()
        const url = this._updateURLParams(trigger.name, trigger.value)
        const openFilters = this._getOpenFilters()

        await this._refreshCollection(url, () => {
          document.body.classList.remove('overlay-shown')
          openFilters.forEach(filter => this._openFilter(filter))
        }, e)
      })
    })

    this._filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', async (e) => {
        e.preventDefault()
        const openFilters = this._getOpenFilters()

        await this._refreshCollection(trigger.href, () => {
          document.body.classList.remove('overlay-shown')
          trigger.closest('.filter-item').querySelector('.filter-trigger').click()
        }, e)
      })
    })

    if (!this._ctx.getState().CollectionFiltersMounted) {
      this._openFirstFilter()
    }

    this._ctx.hydrate({ CollectionFiltersMounted: true })

    this._elem.classList.add('rendered')

    this._setupToggleEvents()
  }


  _setupToggleEvents = () => {
    for (const toggleElem of this._filterToggles) {
      toggleElem.addEventListener('click', (e) => {
        e.preventDefault()
        const textElem = toggleElem.querySelector('[data-collection-filter-toggle-text]')
        const toggleOptions = JSON.parse(toggleElem.dataset.collectionFilterToggle)
        const newAttribute = toggleOptions.attribute === 'yes' ? '' : 'yes'
        AjaxApi.updateCart({ attributes: { '_filters-hidden': newAttribute } })

        if (newAttribute === '') {
          this._elem.classList.remove('filters--hidden')
          textElem.textContent = toggleOptions.hideText
        } else {
          this._elem.classList.add('filters--hidden')
          textElem.textContent = toggleOptions.showText
        }

        toggleOptions.attribute = newAttribute
        toggleElem.dataset.collectionFilterToggle = JSON.stringify(toggleOptions)
      })
    }
  }

  _getOpenFilters = () => [...new Set(Array.from(this._elem.querySelectorAll('[data-filter-item-label].open'), elem => elem.dataset.filterItemLabel))];

  _updateURLParams = (param, value) => {
    const baseURL = window.location.pathname
    const params = new URLSearchParams(window.location.search)
    params.set(param, value)
    return `${baseURL}?${params.toString()}`
  }

  _updateHistoryState = (url) => {
    window.history.replaceState(url, '', url)
  }
  _refreshCollection = async (url, cb = false, evt) => {
    this._elem.classList.add('loading')
    const mobileOpen = this._mobileContainer ? this._mobileContainer.classList.contains('open') : false
    const originalScroll = this._mobileScrollContainer ? this._mobileScrollContainer.scrollTop : 0
    const { data } = await axios.get(url)
    const parser = new DOMParser()
    const html = parser.parseFromString(data, 'text/html')
    const fetchedElem = html.querySelector('[data-collection-filters]')
    this._elem.innerHTML = fetchedElem.innerHTML

    const fetchedCount = html.querySelector('[data-product-count]')

    if(fetchedCount && document.querySelector('[data-product-count]')) {
      document.querySelector('[data-product-count]').innerHTML = fetchedCount.innerHTML
    }

    if (cb) cb()

    if (mobileOpen) {
      const mobileContainer = this._elem.querySelector('[data-collection-filters-mobile]')
      if (!evt || !evt.target.dataset.sortTrigger) {
        mobileContainer.classList.add('open')
        this._ctx.emit('ffc--clear-all-scroll-locks')
      }

      const scrollContainer = mobileContainer.querySelector('[data-collection-filters-scroll]')
      this._ctx.emit('ffc--scroll-lock-elem', null, scrollContainer)
      scrollContainer.scrollTo(0, originalScroll)
    }

    this._ctx.emit('ffc--lazy-load-update')
    this._ctx.emit('ffc--quicklink-listen-to', null, this._elem)
    this._theme.mountComponents(this._elem.closest('[data-collection-filters-wrap]'))
    this._updateHistoryState(url)
    this._elem.classList.remove('loading')

    const scrolltToTop = window.pageYOffset + this._scrollElem.getBoundingClientRect().top - this._offset + 1
    window.scrollTo({ top: scrolltToTop })

    try {
      const YotpoAPI = new Yotpo.API(yotpo);
      YotpoAPI.refreshWidgets();
    } catch (e) {
      console.error('yotpo error', e);
    }

    this._setupToggleEvents()
  }

  _openFilter = (name) => {
    const elems = this._elem.querySelectorAll(`[data-filter-item-label="${name}"]`)
    for (const elem of elems) {
      elem.classList.add('open')
      elem.nextElementSibling.classList.add('open')
    }
  }

  _clearFilters = () => {
    let url = window.location.pathname
    const searchQuery = new URLSearchParams(window.location.search).get('q')

    if (searchQuery) {
      url = `${url}?q=${searchQuery}`
    }

    this._refreshCollection(url)
  }

  _openFirstFilter = () => {
    const elems = this._elem.querySelectorAll(`[data-filter-item]:first-child [data-filter-item-label]`)
    for (const elem of elems) {
      elem.classList.add('open')
      elem.nextElementSibling.classList.add('open')
    }
  }

}